export const messageCode = {
    changeTab: 1 ,
    requirementError: 3,
    savingSuccessfully: 4,

    deleteError: 55,
    deleteSuccessfully: 54,
    changeStatusError: 57,
    changeStatusSuccessfully: 56,
    archivedError: 69,
    archivedSuccessfully: 68,
    archivedConfirmation: 71,
    noFileSelected: 60,
    marketingCampaignCancelledSuccessfully: 83,
    SurveyIsTaken: 64,
    codeExist: 99,
    UnValidCode : 100 ,
    userAlreadyExists : 103 ,
    npsCloseStatusConfirmation:104,
    vinIsEmpty:105,
    UnableToSavehanges:77,
    ErrorSelectRows:107,
    DeleteBookingRecurrance:111,
    DeleteBooking:109,
    DonotHaveRecurence:110,
    SaveLocalizationSuccessfully:112,
    ReactivateContacr:113,
};
